export default __webpack_public_path__ + "static/media/arrow_down_filter_3.173852be.svg";